import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

const categoryBgColors = [
  'bg-foreground-900',
  'bg-secondary-600',
  'bg-primary-500',
];

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="mb-8">
        <p className="text-xs text-foreground-500 uppercase tracking-widest mb-2">
          CATEGORIES
        </p>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
          漫画分类
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {categories.slice(0, 3).map((cat, index) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`group rounded-2xl overflow-hidden p-6 md:p-8 flex flex-col justify-between min-h-[200px] cursor-pointer transition-transform duration-300 hover:-translate-y-1 ${
              index === 1
                ? 'relative'
                : categoryBgColors[index]
            }`}
          >
            {index === 1 && (
              <>
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20scene%2C%20magical%20forest%20with%20glowing%20elements%2C%20ethereal%20atmosphere%2C%20soft%20natural%20greens%2C%20artistic%20illustration%20style%2C%20dreamy%20mood%2C%20painterly%20texture&width=800&height=600&seq=cat-fantasy-bg&orientation=landscape"
                  alt={cat.name}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/40"></div>
              </>
            )}
            <div className="relative z-10">
              {index === 1 ? (
                <span className="inline-block bg-background-50/20 backdrop-blur-sm rounded-full px-3 py-1 text-xs text-white mb-3">
                  <i className={`${cat.icon} mr-1`}></i>{cat.name}
                </span>
              ) : (
                <div className="w-10 h-10 rounded-full bg-background-50/20 flex items-center justify-center mb-3">
                  <i className={`${cat.icon} text-lg ${index === 0 ? 'text-background-50/70' : 'text-background-50'}`}></i>
                </div>
              )}
            </div>
            <div className="relative z-10">
              <h3 className={`font-heading text-xl md:text-2xl font-bold mb-2 ${
                index === 0 ? 'text-background-50' : index === 1 ? 'text-white' : 'text-background-50'
              }`}>
                {cat.name}
              </h3>
              <p className={`text-sm ${index === 0 ? 'text-background-50/60' : index === 1 ? 'text-white/70' : 'text-background-50/70'}`}>
                {cat.description} · {cat.count.toLocaleString()}部作品
              </p>
            </div>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 mt-4 md:mt-6">
        {categories.slice(3).map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group bg-background-50 rounded-xl p-4 text-center cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:bg-background-100"
          >
            <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-accent-100 flex items-center justify-center">
              <i className={`${cat.icon} text-accent-600 text-lg`}></i>
            </div>
            <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
              {cat.name}
            </h4>
            <p className="text-xs text-foreground-500 mt-1">{cat.count.toLocaleString()}部</p>
          </Link>
        ))}
      </div>
    </section>
  );
}